module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "16px"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dLoading),
      expression: "dLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_sleep')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_banReason')
    },
    model: {
      value: (_vm.notPassDialog),
      callback: function($$v) {
        _vm.notPassDialog = $$v
      },
      expression: "notPassDialog"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_reason'),
      "label-width": "14%"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.notPassDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.verifyRqs('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "none",
      "padding": "0 0px 0 24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('table', {
    staticClass: "ldt-file"
  }, [_c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.fileVersion : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_filetype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getftype[_vm.config.fileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_subtype')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.getstype[_vm.config.subFileType] : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_distributor')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.mechName : ''))])])]), _vm._v(" "), _c('tr', {}, [_c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_adddate')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.createTime : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? (_vm.config.fileSize / 1024).toFixed(2) : '') + "KB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "ldt-word-title"
  }, [_vm._v("MD5：")]), _vm._v(" "), _c('label', {
    staticClass: "ldt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.hashCode : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "ldt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('app_filedesc')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "ldt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0",
      "padding-right": "24px"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config ? _vm.config.memo : ''))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "padding": "10px 0px 24px 0px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.verify('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_psverify')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.verify('3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addtesttask')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openlink
    }
  }, [_vm._v(_vm._s(_vm.$t('app_downfile')))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb4ce0c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/app/verify.vue
// module id = 1134
// module chunks = 0